import { render, staticRenderFns } from "./LabelConfigs.vue?vue&type=template&id=f34da09c&scoped=true"
import script from "./LabelConfigs.vue?vue&type=script&lang=js"
export * from "./LabelConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34da09c",
  null
  
)

export default component.exports